import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { Box, Button } from '@mui/material';
import { Add } from '@mui/icons-material';
import { ScreenFrame, ListCard, ConfirmDialog } from '../PrototypeShared';

const MOCK_USERS = [
  { id: '1', name: 'Admin User', role: 'Admin', status: 'Active' },
  { id: '2', name: 'Quality User', role: 'Quality', status: 'Active' },
];

export default function UsersScreen() {
  const [approveModal, setApproveModal] = useState(false);

  return (
    <ScreenFrame
      title="User management"
      actions={
        <>
          <Button component={Link} to="/prototype/administration/master-data" variant="outlined" size="small">Master data</Button>
          <Button startIcon={<Add />} variant="contained" size="small" onClick={() => setApproveModal(true)}>Add user (modal)</Button>
        </>
      }
    >
      <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
        {MOCK_USERS.map((u) => (
          <ListCard key={u.id} title={u.name} subtitle={u.role} status={u.status} to={`/prototype/profile`} />
        ))}
      </Box>
      <ConfirmDialog open={approveModal} title="Add user" message="This would open an add-user form. For prototype, close to continue." onConfirm={() => setApproveModal(false)} onCancel={() => setApproveModal(false)} />
    </ScreenFrame>
  );
}
